"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtemisAPI = void 0;
const UserRole_1 = require("@reality/db/lib/types/UserRole");
const t = __importStar(require("io-ts"));
const Endpoint_1 = require("../common/Endpoint");
const types_1 = require("./types");
exports.ArtemisAPI = {
    account: {
        create: Endpoint_1.Endpoint.public(t.type({
            username: t.string,
            password: t.string,
            createToken: t.string,
        }), t.type({ artemisToken: t.string })),
        login: Endpoint_1.Endpoint.public(t.type({ username: t.string, password: t.string }), t.type({ artemisToken: t.string })),
        usernameExists: Endpoint_1.Endpoint.public(t.type({ username: t.string }), t.type({ exists: t.boolean })),
        resetPassword: Endpoint_1.Endpoint.public(t.type({ password: t.string, resetToken: t.string }), t.type({ username: t.string, artemisToken: t.string })),
    },
    friends: {
        add: Endpoint_1.Endpoint.authenticated(t.type({ friend: t.string }), t.type({}), [
            UserRole_1.UserRole.Admin,
            UserRole_1.UserRole.Hacker,
            UserRole_1.UserRole.Mentor,
            UserRole_1.UserRole.Sponsor,
        ]),
        remove: Endpoint_1.Endpoint.authenticated(t.type({ friend: t.string }), t.type({}), [
            UserRole_1.UserRole.Admin,
            UserRole_1.UserRole.Hacker,
            UserRole_1.UserRole.Mentor,
            UserRole_1.UserRole.Sponsor,
        ]),
        get: Endpoint_1.Endpoint.authenticated(t.type({}), t.type({ friends: t.array(t.string) }), [
            UserRole_1.UserRole.Admin,
            UserRole_1.UserRole.Hacker,
            UserRole_1.UserRole.Mentor,
            UserRole_1.UserRole.Sponsor,
        ]),
    },
    tokens: {
        issueCreate: Endpoint_1.Endpoint.authenticated(t.type({
            realName: t.string,
            email: t.string,
            role: UserRole_1.UserRoleCodec,
        }), t.type({ token: t.string }), [UserRole_1.UserRole.Admin]),
        issuePasswordReset: Endpoint_1.Endpoint.authenticated(t.type({
            username: t.string,
        }), t.type({ token: t.string }), [UserRole_1.UserRole.Admin]),
    },
    system: {
        stats: Endpoint_1.Endpoint.authenticated(t.type({}), t.type({
            apollo: t.array(types_1.ApolloStatsCodec),
            artemis: types_1.ArtemisStatsCodec,
        }), [UserRole_1.UserRole.Admin]),
    },
    cluster: {
        dispatch: Endpoint_1.Endpoint.authenticated(t.type({
            regionId: t.string,
        }), t.union([
            t.type({
                success: t.literal(true),
                assetServer: t.string,
                gaiaHost: t.string,
                gaiaPort: t.number,
                gaiaToken: t.string,
            }),
            t.type({
                success: t.literal(false),
            }),
        ]), [UserRole_1.UserRole.Admin, UserRole_1.UserRole.Hacker, UserRole_1.UserRole.Mentor, UserRole_1.UserRole.Sponsor]),
        purgeUser: Endpoint_1.Endpoint.authenticated(t.type({
            username: t.string,
        }), t.type({}), [UserRole_1.UserRole.Admin]),
    },
};
//# sourceMappingURL=artemis.js.map